var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNogroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_182771",
    "data-name": "Group 182771",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.307,
    height: 191.693,
    viewBox: "0 0 300.307 191.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164489",
    "data-name": "Rectangle 164489",
    width: 300.307,
    height: 191.693,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164486",
    "data-name": "Rectangle 164486",
    width: 130.186,
    height: 76.213,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182770",
    "data-name": "Group 182770",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182769",
    "data-name": "Group 182769",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182768",
    "data-name": "Group 182768",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98666",
    "data-name": "Path 98666",
    d: "M123.357,74.268S170.28,87.78,196.514,34.129,165.3.8,141.5,22.831c-14.1,13.049-44.693,41.5-18.138,51.437",
    transform: "translate(-94.008 0.001)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98667",
    "data-name": "Path 98667",
    d: "M59.659,227.789H235.09c19.1,0,37.109-7.8,48.2-21.1,13.986-16.76,24.913-45.007,9.536-89.887-29.5-86.1-132.675-84.884-155.124-55.132C107.659,101.5,69.173,129.1,45.2,129.1c-6.221,0-13.086,2.313-19.819,6.315-47.626,28.306-23.721,92.377,34.274,92.377",
    transform: "translate(0 -36.096)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98668",
    "data-name": "Path 98668",
    d: "M535.027,366.292v84.154l-36.825,13.8V366.292Z",
    transform: "translate(-414.932 -305.069)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98669",
    "data-name": "Path 98669",
    d: "M493.683,460.636a.907.907,0,0,1-.907-.907V361.773a.907.907,0,0,1,.907-.907h36.825a.907.907,0,0,1,.907.907v84.154a.907.907,0,0,1-.589.849L494,460.579a.905.905,0,0,1-.318.058m.907-97.956v95.741L529.6,445.3V362.68Z",
    transform: "translate(-410.413 -300.55)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164485",
    "data-name": "Rectangle 164485",
    width: 93.362,
    height: 84.154,
    transform: "translate(120.095 61.223)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98670",
    "data-name": "Path 98670",
    d: "M807.366,446.834H714a.907.907,0,0,1-.907-.907V361.774a.907.907,0,0,1,.907-.907h93.362a.907.907,0,0,1,.907.907v84.153a.907.907,0,0,1-.907.907m-92.456-1.814h91.549v-82.34H714.911Z",
    transform: "translate(-593.909 -300.551)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98671",
    "data-name": "Path 98671",
    d: "M628.39,869.779v13.8H498.2l36.825-13.8Z",
    transform: "translate(-414.932 -724.403)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98672",
    "data-name": "Path 98672",
    d: "M623.87,879.971H493.683a.907.907,0,0,1-.318-1.756l36.825-13.8a.911.911,0,0,1,.318-.057H623.87a.907.907,0,0,1,.907.907v13.8a.907.907,0,0,1-.907.907m-125.184-1.814H622.964V866.168H530.672Z",
    transform: "translate(-410.413 -719.884)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98673",
    "data-name": "Path 98673",
    d: "M498.2,297.517l36.823-13.8H665.212l-36.824,13.8Z",
    transform: "translate(-414.932 -236.295)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98674",
    "data-name": "Path 98674",
    d: "M623.869,293.905H493.682a.907.907,0,0,1-.318-1.756l36.824-13.8a.908.908,0,0,1,.318-.058H660.692a.907.907,0,0,1,.318,1.756l-36.823,13.8a.906.906,0,0,1-.318.058m-125.183-1.814H623.7L655.689,280.1H530.67Z",
    transform: "translate(-410.412 -231.776)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98675",
    "data-name": "Path 98675",
    d: "M1277.1,395.473l36.824-13.8V283.716l-36.824,13.8Z",
    transform: "translate(-1063.645 -236.295)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98676",
    "data-name": "Path 98676",
    d: "M1272.584,391.861a.907.907,0,0,1-.907-.907V293a.907.907,0,0,1,.589-.849l36.823-13.8a.907.907,0,0,1,1.225.849v97.956a.907.907,0,0,1-.588.849L1272.9,391.8a.9.9,0,0,1-.318.058m.907-98.234v96.019l35.009-13.122V280.5Z",
    transform: "translate(-1059.127 -231.775)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98677",
    "data-name": "Path 98677",
    d: "M434.847,205.432H565.034l-12.715-32.282H422.133Z",
    transform: "translate(-351.577 -144.209)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98678",
    "data-name": "Path 98678",
    d: "M560.515,201.819H430.328a.907.907,0,0,1-.844-.575L416.77,168.962a.907.907,0,0,1,.844-1.239H547.8a.907.907,0,0,1,.844.575l12.714,32.282a.907.907,0,0,1-.844,1.239m-129.569-1.814H559.183l-12-30.469H418.945Z",
    transform: "translate(-347.057 -139.689)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98679",
    "data-name": "Path 98679",
    d: "M429.494,964.108H299.308l33.244-11.753H462.738Z",
    transform: "translate(-249.281 -793.177)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98680",
    "data-name": "Path 98680",
    d: "M424.975,960.5H294.788a.907.907,0,0,1-.3-1.762l33.244-11.753a.9.9,0,0,1,.3-.052H458.219a.907.907,0,0,1,.3,1.762l-33.244,11.753a.905.905,0,0,1-.3.052m-124.9-1.814H424.819l28.113-9.939H328.188Z",
    transform: "translate(-244.762 -788.657)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98681",
    "data-name": "Path 98681",
    d: "M1301.437,476,1277.1,464.248V366.292l24.332,11.752Z",
    transform: "translate(-1063.647 -305.069)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98682",
    "data-name": "Path 98682",
    d: "M1296.918,472.389a.905.905,0,0,1-.394-.09l-24.332-11.752a.907.907,0,0,1-.513-.817V361.773a.907.907,0,0,1,1.3-.816l24.332,11.752a.907.907,0,0,1,.513.816v97.956a.907.907,0,0,1-.907.907m-23.425-13.228,22.518,10.876V374.095l-22.518-10.876Z",
    transform: "translate(-1059.128 -300.55)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98683",
    "data-name": "Path 98683",
    d: "M398.339,388.264l16.691,12.7V303.008l-16.691-12.7Z",
    transform: "translate(-331.76 -241.785)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98684",
    "data-name": "Path 98684",
    d: "M410.51,397.352a.906.906,0,0,1-.549-.185l-16.691-12.7a.907.907,0,0,1-.358-.722V285.789a.907.907,0,0,1,1.456-.722l16.691,12.7a.907.907,0,0,1,.358.722v97.956a.907.907,0,0,1-.907.907M394.726,383.3l14.878,11.32V298.939l-14.878-11.32Z",
    transform: "translate(-327.24 -237.266)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_182767",
    "data-name": "Group 182767",
    transform: "translate(83.27 61.223)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182766",
    "data-name": "Group 182766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182765",
    "data-name": "Group 182765",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98685",
    "data-name": "Path 98685",
    d: "M498.2,366.292v54.854l36.825,21.359h93.362V366.292Z",
    transform: "translate(-498.202 -366.292)",
    fill: "#b3b3b3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_98698",
    "data-name": "Path 98698",
    d: "M1182.533,471.69a18.272,18.272,0,1,1-18.272-18.272,18.272,18.272,0,0,1,18.272,18.272",
    transform: "translate(-954.446 -377.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98699",
    "data-name": "Path 98699",
    d: "M1170.429,607.976h-16.286a.746.746,0,0,1-.307-1.427c3.606-1.606,8.389-4.646,8.541-9.518.245-7.848,8.052,10.945,8.052,10.945",
    transform: "translate(-960.614 -495.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98700",
    "data-name": "Path 98700",
    d: "M1222.374,510.7q-1.5,0-1.684-1.964l-.218-2.557a1.9,1.9,0,0,1,.374-1.5,2.79,2.79,0,0,1,1.434-.78q2.432-.717,2.432-2.806a2.831,2.831,0,0,0-.592-1.886,2.2,2.2,0,0,0-1.777-.7,2.3,2.3,0,0,0-2.027,1,4.305,4.305,0,0,1-1.185,1.247,2.172,2.172,0,0,1-1.372.156,2.219,2.219,0,0,1-1.5-.811,1.451,1.451,0,0,1-.062-1.59,5.984,5.984,0,0,1,2.385-2.619,7.146,7.146,0,0,1,3.758-.967,7.706,7.706,0,0,1,3.43.733,5.509,5.509,0,0,1,2.339,2.12,6.286,6.286,0,0,1,.842,3.321,4.765,4.765,0,0,1-1.341,3.524,7.484,7.484,0,0,1-3.461,1.9l-.156,2.214q-.157,1.964-1.621,1.964m-.031,6.892a2.526,2.526,0,1,1,0-5.052,2.492,2.492,0,0,1,1.809.733,2.522,2.522,0,0,1,0,3.586,2.491,2.491,0,0,1-1.809.733",
    transform: "translate(-1012.752 -412.201)",
    fill: "#b3b3b3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNogroup);
export default __webpack_public_path__ + "static/media/nogroup.a68e31530981a271f5efc7ac2d1745f4.svg";
export { ForwardRef as ReactComponent };